import SearchComponent from '@components/Default/Search/SearchComponent';
import TableComponent from '@components/TableComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Icon, Input, Modal, Row, Select, Tooltip } from 'antd';
import React from 'react';
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';

import ConditionSectionFormflow from './ConditionSectionFormflow';
import IBaseComponent from './Interfaces/Base/IBaseComponent';
import IConfirmComponent from './Interfaces/FormflowComponents/IConfirmComponent';
import ISection from './Interfaces/ISection';
import TaskComponent from './TaskComponent';
import FormflowContext from './Util/FormflowContext';

const Option = Select.Option;
const columns = [
  {
    title: 'table.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.auditors.registration',
    dataIndex: 'username',
    key: 'username'
  },
];

interface ISectionComponentPropType {
  closeModal: any;
  conditionIsBroken: any;
  currentSection: ISection;
  defaultValueInput?: string;
  footerShow?: boolean;
  idxSection: number;
  inputValue: string;
  isComponentModalOpen: boolean;
  modalRemoveSection: any;
  onClickLinkedButton: Function;
  onClickRemoveButton: Function;
  onInputChange: Function;
  sectionComponents: IBaseComponent[];
  sectionConditions: any;
  sectionLinked: any;
  sectionLinkedSelect: string[] | null;
  sizeSection?: number;
  titleSection: any;
  valueIDSection: string;
  visibleRemoveModal: boolean;
  sectionLinkOnChange: any;
  tableApproverUsers: any;
  approversUsers: string[];
  loadMoreUsers: Function;
  curOffset?: string;
  handleUsersSearch: Function;
};

interface ISectionComponentStateType {
  conditionModalVisible: boolean;
  currentSection: any;
  fieldSelect: string;
  formflowTaskComponents: IBaseComponent[];
  isComponentModalOpen: boolean;
  titleConfirmConditionNo: string;
  titleConfirmConditionYes: string;
  typeConditionComponent: string;
  checkedApproveSection: boolean;
  approverUsersModalVisible: boolean;
  selectApproverUsers: any;
};

const confirm = Modal.confirm;

const SortableItem = SortableElement<any>(({ value }) => <li style={{ listStyleType: "none" }}>{value}</li>);

const SortableList = SortableContainer<any>(({ items }) => {
  return (
    <ul>
      {items.map((value: any, index: number) => (
        <SortableItem key={`item-${index}`} index={index} value={value} />
      ))}
    </ul>
  );
});

export class Component implements IBaseComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = 0;
    this.title = '';
    this.description = '';
    return this;
  }
}

export default class SectionComponent extends React.Component<ISectionComponentPropType, ISectionComponentStateType> {

  private updateSectionMethod?: Function;

  constructor(props: ISectionComponentPropType) {
    super(props);

    this.getTitleComponentCondition = this.getTitleComponentCondition.bind(this);
    this.setSectionUpdateMethod = this.setSectionUpdateMethod.bind(this);

    this.state = {
      conditionModalVisible: false,
      fieldSelect: '',
      formflowTaskComponents: [new Component()],
      titleConfirmConditionYes: '',
      titleConfirmConditionNo: '',
      typeConditionComponent: '',
      currentSection: '',
      isComponentModalOpen: false,
      checkedApproveSection: (this.props.approversUsers && this.props.approversUsers.length > 0) ? true : false,
      approverUsersModalVisible: false,
      selectApproverUsers: this.props.approversUsers ? this.props.approversUsers : []
    };
  }

  onSortEnd = async ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
    this.setState({
      formflowTaskComponents: arrayMove(this.state.formflowTaskComponents, oldIndex, newIndex),
    });

    if (this.updateSectionMethod) {
      this.updateSectionMethod(this.state.formflowTaskComponents, this.props.currentSection)
    }
    else console.error("cant access update method");
  };

  componentDidMount() {
    this.setState({ formflowTaskComponents: this.props.sectionComponents });
  }

  renderSectionComponents() {
    const sectionFormflowComponents: JSX.Element[] = [];
    for (const [index, component] of this.props.sectionComponents.entries()) {
      sectionFormflowComponents.push(
        <TaskComponent key={index} section={this.props.currentSection} index={index} component={component} />
      );
    }
    return sectionFormflowComponents;
  }

  getSectionConditions() {
    let sectionConditions: JSX.Element[] = [];
    if (this.props.sectionConditions !== undefined && this.props.sectionConditions !== null) {
      sectionConditions.push(
        <Tooltip key={1} title={this.props.sectionConditions.length > 1 ?
          (this.props.sectionConditions.length + ' ' + I18n.l("formflow.labels.conditions")) :
          (this.props.sectionConditions.length + ' ' + I18n.l("formflow.labels.condition"))}>
          <span className="font-conditions" key={1}>
            {this.props.sectionConditions.length + '   '}
            <FontAwesomeIcon key={1} className="icon-conditions" icon='code-branch' />
          </span>
        </Tooltip>
      )
    }
    return sectionConditions;
  }

  handleChangeLink = async (value: any) => {
    this.setState({ fieldSelect: value });
  }

  onCloseModal = async () => {
    this.setState({ conditionModalVisible: false })
  }

  handleIDSection = async () => {
    this.setState({
      conditionModalVisible: !this.state.conditionModalVisible,
      currentSection: this.props.currentSection,
    });
    await this.getTitleConfirmCondition();
  }

  getTitleComponentCondition() {
    let titleComponentCondition: any
    this.props.sectionComponents.forEach((components: any) => {

      if (components.id === this.props.sectionConditions[0].rules[0].xItem.id) {
        titleComponentCondition = components.title
      }
    })
    return titleComponentCondition
  }

  getTitleConfirmCondition = async () => {
    const component = this.props.sectionComponents.find((component: IBaseComponent) => component.type === ComponentType.CONFIRM);

    if (component) {
      const confirmComponent: IConfirmComponent = component as IConfirmComponent;
      this.setState({
        titleConfirmConditionYes: confirmComponent.yesLabel,
        titleConfirmConditionNo: confirmComponent.noLabel
      });
    }
  }


  showDeleteConfirm(onDelete: Function) {
    confirm({
      title: I18n.l("formflow.labels.titleRemoveComponent"),
      content: I18n.l("formflow.labels.removeSection"),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  validationSection() {
    let fieldIsRequired: JSX.Element = <div />;
    if (!!!this.props.inputValue || this.props.inputValue !== undefined && this.props.inputValue.length === 0) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }

  async setSectionUpdateMethod(updateSectionMethod: Function) {
    this.updateSectionMethod = updateSectionMethod;
  }

  onChangeAproveSection = async (evt: any) => {
    this.setState({ checkedApproveSection: evt.target.checked })
  }

  toggleApproverUsersModal = () => {
    this.setState({
      approverUsersModalVisible: !this.state.approverUsersModalVisible,

    });
  }
  onRadioItemSelectionChange = async (userId: string) => {
    this.setState({
      // haveItemSelected: !!userId,
      selectApproverUsers: userId,
    });
  }

  getUsers = () => {
    const rowSelection = {
      onChange: async (selectedRowKeys: any, selectedRows: any) => {
        this.setState({ selectApproverUsers: selectedRowKeys })
      },
      selectedRowKeys: this.state.selectApproverUsers
    };
    return rowSelection;
  }
  onClickSaveApprover = async (updateFormflowApproverUsers: (approvers: string[], currentSection: ISection) => void) => {
    await updateFormflowApproverUsers(this.state.selectApproverUsers, this.props.currentSection);
    this.setState({ approverUsersModalVisible: false })
  }

  render() {
    const {
      onInputChange,
      sizeSection,
      titleSection,
      inputValue,
      sectionLinkedSelect,
      valueIDSection,
      idxSection,
      sectionComponents,
      sectionLinked,
      onClickRemoveButton
    } = this.props;
    
    return (
      <CardStyle style={this.props.sectionComponents.length === 0 || this.props.conditionIsBroken !== undefined ? { border: '2px solid', borderColor: Theme.secondary.red } : { border: '0px' }}  >
        <CardHeaderStyle>
          <p>{titleSection}</p>
          <div className="input-style">
            <Input
              defaultValue={inputValue}
              className={inputValue.length === 65 ? "apply-shake" : ''}
              maxLength={65}
              value={inputValue}
              onChange={onInputChange()}
              style={inputValue === '' ? { borderColor: `${Theme.secondary.red}` } : {}}
            />
            {this.validationSection()}
            <p style={{ float: 'right' }} className={inputValue.length < 65 ? "count-input" : "count-input-red"} >
              {inputValue.length !== 0 ? inputValue.length + ' / 65' : '0 / 65'}
            </p>
          </div>
        </CardHeaderStyle>
        <FormflowContext.Consumer>
          {({ setCurrentComponent, setComponentsInSection }) => (
            this.setSectionUpdateMethod(setComponentsInSection),
            <React.Fragment>
              <CardContentStyle>
                <SortableList items={this.renderSectionComponents()} onSortEnd={this.onSortEnd} />
                {this.props.sectionComponents.length === 0 &&
                  <div className='item-container' onClick={() => { setCurrentComponent(new Component(), this.props.currentSection) }}>{I18n.l("formflow.buttons.createNewTask")}</div>
                }
              </CardContentStyle>

              {this.props.sectionComponents.length > 0 &&
                <Button style={{ fontWeight: 'bold', paddingLeft: '40%', marginBottom: '16px' }} onClick={() => { setCurrentComponent(new Component(), this.props.currentSection) }} className="goepik-btn-border-main-withoutbold">
                  <Icon type="plus" /> {I18n.l("formflow.buttons.createNewComponent")}
                </Button>
              }

            </React.Fragment>
          )}
        </FormflowContext.Consumer>
        {(sizeSection !== undefined ? sizeSection > 1 : undefined) &&
          <CardFooterStyle>
            <span className="font-styled" >{I18n.l("formflow.labels.nextSection")}</span>
            <Select key={1} defaultValue={sectionLinkedSelect === null ? 'end' : sectionLinkedSelect} className="select-linked" onChange={this.props.sectionLinkOnChange()}>
              {sectionLinked.map((titleLinks: any, idx: number) => {
                return <Option key={idx + 1} value={titleLinks}>
                  {
                    (titleLinks === '') &&
                    I18n.l("formflow.labels.section") + " " + (idx + 1)
                  }
                  {(titleLinks !== '') &&
                    titleLinks
                  }
                </Option>
              })}
              <Option value="end">{I18n.l("formflow.labels.finishSection")}</Option>
            </Select>

            <Button className="goepik-btn-border-main-withoutbold" onClick={this.toggleApproverUsersModal} >
              {I18n.l("formflow.labels.aproverUsers")}
            </Button>

            <React.Fragment>
              <ButtonStyle>
                {
                  this.props.sectionComponents.length > 0 &&
                  <span>
                    {this.props.conditionIsBroken}
                    <Button className="goepik-btn-border-main-withoutbold" onClick={this.handleIDSection} >
                      {I18n.l("formflow.buttons.configSection")}
                    </Button>
                  </span>
                }
                {this.getSectionConditions()}
                <Button style={{ border: '0px' }} type="danger" ghost onClick={() => this.showDeleteConfirm(onClickRemoveButton())} >
                  {I18n.l("formflow.buttons.removeSection")}
                </Button>
              </ButtonStyle>
            </React.Fragment>
          </CardFooterStyle>
        }

        {this.state.conditionModalVisible && (
          <ConditionSectionFormflow
            modalVisible={this.state.conditionModalVisible}
            onCloseModal={this.onCloseModal}
            titleConditionModal={I18n.l("formflow.labels.section") + ' ' + idxSection}
            subtitleConditionModal={valueIDSection}
            selectComponentCondition={sectionComponents}
            sectionLinkedCondition={sectionLinked}
            titleComponentCondition={() => this.getTitleComponentCondition()}
            titleRadioConfirmYes={this.state.titleConfirmConditionYes}
            titleRadioConfirmNo={this.state.titleConfirmConditionNo}
            currentSection={this.state.currentSection}
          />
        )}
        {this.state.approverUsersModalVisible &&
          <Modal width={800} onCancel={this.toggleApproverUsersModal} visible={this.state.approverUsersModalVisible} footer={false}>
            <ModalTitle>{I18n.l("formflow.labels.aproverUsers")}</ModalTitle>
            <ModalContent>
              <SearchResponsible>
                <SearchComponent
                  onSubmit={this.props.handleUsersSearch}
                  placeholder='form.placeholders.alertsSearch'
                  buttonText='form.buttons.search'
                />
              </SearchResponsible>
              <ApproverTable>
                <TableComponent
                  rowSelection={this.getUsers()}
                  columns={columns}
                  data={this.props.tableApproverUsers}
                  showConfirmationModal={false}
                  scroll={{ y: 240 }}
                  noPagination={true}
                />
              </ApproverTable>

              {this.props.curOffset != undefined && this.props.curOffset != null && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  onClick={() => this.props.loadMoreUsers()}
                >
                  {I18n.l('common.seeMore')}
                </Button>
              )}

              <p className="goepik-component-padding"></p>
              <FormflowContext.Consumer>
                {({ updateFormflowApproverUsers }) => (
                  <Row type="flex" justify="end">
                    <Button className="main-button" type="primary" ghost size="large" onClick={this.toggleApproverUsersModal}>
                      {I18n.l('common.cancel')}
                    </Button>
                    <Button className="main-button" type="primary" size="large" onClick={() => { this.onClickSaveApprover(updateFormflowApproverUsers) }}>
                      {I18n.l('common.select')}
                    </Button>
                  </Row>
                )}
              </FormflowContext.Consumer>
            </ModalContent>
          </Modal>
        }
      </CardStyle>
    );
  }
}


const CardStyle = styled.div`
    width: 100%;
    background: ${Theme.secondary.darkWhite};
    border-radius: 5px;
    margin-top: 1rem;
    box-shadow: 3px 5px 25px -5px ${Theme.secondary.midGrey};
    margin-bottom: 1rem;

`
const CardHeaderStyle = styled.div`
    width: 100%;
    border-bottom: 1px solid ${Theme.secondary.midGrey};
    box-shadow: 3px 5px 25px -15px ${Theme.secondary.midGrey};
    padding: 25px;
    .input-style{
        width 50%;
    }

    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

    .apply-shake {
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    }
`;

const CardFooterStyle = styled.div`
    width: 100%;
    border-top: 1px solid ${Theme.secondary.midGrey};
    box-shadow: 3px 5px 25px -15px ${Theme.secondary.midGrey};
    padding: 25px;
    float: right;
    .select-linked{
        width: 20%;
    }
    .font-styled{
        margin:10px;
    }
    Button{
        :after {
            border: 0px;
        }
    }
`
const ButtonStyle = styled.div`
    border: 0px;
    float: right;
    .icon-conditions{
        transform: rotate(90deg);
        vertical-align:-2px;
    }
    .font-conditions{
        font-weight: bold;
    }
    .exclamation-avatar{
      font-size: 1.7rem;
      color:  ${Theme.secondary.red};;
      margin-right: -14px;
      margin-bottom: 5px;
    }
`
const CardContentStyle = styled.div`
    width: 100%;
    padding-top: 25px;
    padding-left: 25px;
    padding-right: 25px;
    .item-container{
      cursor:pointer;
      flex: 1;
      height: 70px;
      background-color: ${Theme.secondary.supahLightGrey};
      border: 1px solid ${Theme.secondary.midLightGrey};
      margin-bottom: 10px;
      border-radius: 5px;
      font-weight: bold;
      color: ${Theme.secondary.midGrey};
      text-align: center;
      padding-top: 1.6rem;
  }

    Button{
        width: 100%;
        height: 5rem;
        background: ${Theme.secondary.supahLightGrey};
        border-color: ${Theme.secondary.lightGrey};
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        :hover {
            width: 100%;
            height: 5rem;
            background: ${Theme.secondary.supahLightGrey};
            border-color: ${Theme.secondary.lightGrey};
            font-weight: bold;
            color: ${Theme.secondary.midGrey};
        }
        :focus {
            width: 100%;
            height: 5rem;
            background: ${Theme.secondary.supahLightGrey};
            border-color: ${Theme.secondary.lightGrey};
            font-weight: bold;
            color: ${Theme.secondary.midGrey};
        }
    }
`

const ModalTitle = styled.h3`
   font-size: 22px;
 `;

const ModalContent = styled.div`
 width: 100%;
                    
 .form-item-title{
   font-weight: bold;
   color:#333;
 }
 .form-item-error{
   color: #f00;
   margin-bottom:0px;
 }
                    
 .bottomAlign {
   position: absolute;
   bottom: 13px;
 }
 
 `;

const SearchResponsible = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;
const ApproverTable = styled.div`
   .ant-table-fixed-header .ant-table-scroll .ant-table-header {
        overflow: hidden;
    }
    
`;